<script>
import VStakeholders from "./components/VStakeholders.vue";
import StakeholderCategoryService from "@/services/StakeholderCategoryService";
import VStakeholderCategoryForm from "@/components/Forms/VStakeholderCategoryForm.vue";
import { EventBus } from "@/libraries/EventBus";

export default {
    props: {
        project_id: {}
    },
    data() {
        return {
            loading: true,
            categories: [],
            showModalStakeholderCategory: false
        };
    },
    components: { VStakeholders, VStakeholderCategoryForm },
    async created() {
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        eventize(type) {
            if (type === "open") {
                EventBus.$emit("stakeholder-data-tab-open");
            } else {
                EventBus.$emit("stakeholder-data-tab-close");
            }
        },
        async fetchData() {
            try {
                const { data } = await StakeholderCategoryService.GET({
                    project_id: this.project_id
                });
                this.categories = data.data;
            } catch (e) {
                console.log("e", e);
            }
        },
        async catCloseReload() {
            this.loading = true;
            await this.fetchData();
            this.loading = false;
            this.showModalStakeholderCategory = false;
        }
    }
};
</script>

<template>
    <div>
        <base-header class="pb-1" type="">
            <bread-bag>
                <base-button
                    @click="eventize('open')"
                    type="primary"
                    size="sm"
                    outline
                    ><i class="far fa-plus"></i>
                    {{ $t("milestones.expand_all") }}</base-button
                ><base-button
                    @click="eventize('close')"
                    type="primary"
                    size="sm"
                    outline
                    ><i class="far fa-minus"></i>
                    {{ $t("milestones.fold_all") }}</base-button
                >
                <base-button
                    @click="showModalStakeholderCategory = true"
                    class=""
                    type="primary"
                    size="sm"
                >
                    <i class="far fa-plus"></i>
                    {{ $t("stakeholders.create_category") }}
                </base-button></bread-bag
            >
        </base-header>

        <v-loader :loading="loading" v-if="loading" />
        <template v-else-if="categories.length > 0">
            <v-stakeholders
                v-for="(item, i) in categories"
                :key="i"
                :category="item"
                @reload="fetchData"
            />
        </template>
        <template v-else>
            <div class="container-fluid">
                <div class="row card-wrapper">
                    <div class="col-12">
                        <div class="alert alert-warning">
                            {{
                                $t(
                                    "stakeholders.there_are_no_stakeholder_data_in_db"
                                )
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <portal to="modals">
            <v-stakeholder-category-form
                v-if="showModalStakeholderCategory"
                @close="showModalStakeholderCategory = false"
                @close-reload="catCloseReload"
                :project-id="project_id"
            />
        </portal>
    </div>
</template>
